<template>
  <div>
    <div v-if="!periodEnd(periodActive.finalDate) && periodActive.finalDate && hasPermission([consts.permissions.CREATE_ACADEMIC_MANAGEMENT])">
      <div class="font-weight-bold mb-3">Periodos académicos finalizados</div>
    </div>
    <!-- <div v-if="hasRole(['ESTUDIANTE', 'PADRE_MADRE'])">
      <div class="font-weight-bold mb-3">Periodos académicos finalizados</div>
    </div> -->
    <div>
      <div class="kit__utils__heading">
        <h5>
          <span class="mr-3">Lista de clases</span>
          <template v-if="hasPermission([consts.permissions.DOWNLOAD_GROUP_BASE__REPORT])">
            <b-dropdown id="dropdown-1" dropright variant="outline-secondary" class="m-2" menu-class="w-110" no-caret>
              <template #button-content>
                Descargar Reporte de <i class="fe fe-arrow-right mt-3" />
              </template>
              <b-dropdown-item @click="showDownloadReportModal(1)">Notas</b-dropdown-item>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item @click="downloadReportZero()">Yo puedos en 0</b-dropdown-item>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item @click="showDownloadReportModal(3)">Yo puedos bajo rendimiento</b-dropdown-item>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item @click="showGroupExcelReport()">Listado de estudiantes</b-dropdown-item>
              <template v-if="hasPermission([
                    consts.permissions.DOWNLOAD_GROUP_FULL_REPORT
                  ])">
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="showDownloadReportModal(2)">Excelencia académica + promedio</b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="showDownloadReportModal(4)">Excelencia académica lista</b-dropdown-item>
              </template>
            </b-dropdown>
          </template>
          <template v-if="hasPermission([
            consts.permissions.DOWNLOAD_STUDENT_REPORT
          ])">
            <router-link :to="{ name: 'academicReport'}" class="btn btn-light btn-sm">
              <i class="fa fa-eye" /> Ver reportes{{this.$store.state.user.roles.includes(consts.roles.PADRE_MADRE) ? ' de mis hijos': ''}}
            </router-link>
          </template>
        </h5>
      </div>
      <div v-if="!currentPeriod">
        <div class="p-5 font-size-30">
          <div class="font-weight-bold mb-3">Periodos académicos finalizados</div>
          <div>Pronto habilitaremos nuevamente este módulo para que puedas {{ `${hasPermission([consts.permissions.CREATE_CLASSES_RESOURCES]) ? 'revisar y calificar tus estudiantes' : 'revisar y descargar tus notas'}` }}.</div>
          <router-link to="/" class="btn btn-outline-primary width-100">Home</router-link>
        </div>
      </div>
      <div v-if="hasPermission([consts.permissions.READ_ACADEMIC_INFORMATION]) && periodEnd(periodActive.finalDate)">
        <div v-if="(hasPermission([consts.permissions.CREATE_CLASSES_RESOURCES]) || hasPermission([consts.permissions.CREATE_ACADEMIC_MANAGEMENT]))">
          <b>Filtrar por:</b>
          <b-row>
            <b-col sm="3">
              <b-form-group id="input-group-2" label="Grupo" label-for="input-2" description="Seleccione un grupo">
                <b-form-select v-model="filteredGroup" :options="filterGroups"></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
        <template v-if="hasPermission([consts.permissions.READ_ACADEMIC_INFORMATION])">
          <div v-if="hasChildren && !hasPermission([consts.permissions.CREATE_CLASSES_RESOURCES])">
            <b-row>
              <b-col sm="3">
                <b-form-group label="Seleccione el estudiante:" id="input-group-2">
                  <b-form-select v-model="childSelected" :options="children"></b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
          </div>
        </template>
        <template v-if="((hasPermission([consts.permissions.READ_ACADEMIC_INFORMATION]) || hasPermission([consts.permissions.CREATE_ACADEMIC_MANAGEMENT])) && periodEnd(this.periodActive.finalDate))">
          <b-row v-if="!loading">
            <template v-for="(classs, id) in classes">
              <b-col v-if="(periodActive.extraPeriodEvaluation && classs.extraPeriodEvaluation) || (!periodActive.extraPeriodEvaluation)" v-bind:key="id" md="6" lg="4" class="pl-1">
                <b-card
                  no-body
                  header-tag="header"
                  class="m-3"
                >
                <b-card-header header-tag="header" class="powerLine" :style="classs.bannerColor">
                </b-card-header>
                  <b-card-body>
                    <b-row>
                      <b-col>
                        <div v-if="classs.tenuredTeacher">
                          <b-img v-show="classs.loadedImg" right @load="onImgLoad(classs)" style="width:6.8em;height: 6.8em;"
                          :src="`${classs.tenuredTeacher.pathAvatar}?tr=w-500,h-530,fo-auto,r-max`"
                          @error="event => event.target.src = 'https://ik.imagekit.io/czqsnlwbh2e/users/avatars/user-placeholder_LxKtaNY341.webp'"
                          shape="circle" fluid alt="Fluid image"></b-img>
                        </div>
                        <b-skeleton class="float-right" width="6.8em" height="6.8em" type="avatar" v-show="!classs.loadedImg" ></b-skeleton>
                        <h4 class="card-title" v-if="classs.name">{{ classs.name }}</h4>
                        <h4 class="card-title" v-if="classs.subject">{{ classs.subject.name }}</h4>
                        <h6 v-if="classs.group"><b>Grupo:</b><span> {{ classs.group.name }}</span><br></h6>
                        <h6>
                          <b>Docente:</b> {{ teacherName(classs.tenuredTeacher) }}
                        </h6>
                        {{ classs.description }}
                      </b-col>
                    </b-row>
                  </b-card-body>
                  <template #footer>
                    <div v-if="classs.range">
                      <router-link v-if="classs.range.system.name == 'SBG'" :to="{ name: 'newClassroomSBG', params: { idClass: classs.id, childSelected: childSelected }, query: { elective:classs.elective} }" class="btn btn-light mr-2">
                        <i class="fa fa-arrow-right text-blue" /> Ingresar
                      </router-link>
                      <router-link v-if="classs.range.system.name == 'QUANTITATIVE'" :to="{ name: 'classroomTBG', params: { idClass: classs.id, childSelected: childSelected }, query: { elective:classs.elective} }" class="btn btn-light mr-2">
                        <i class="fa fa-arrow-right text-blue" /> Ingresar
                      </router-link>
                    </div>
                  </template>
                </b-card>
              </b-col>
            </template>
          </b-row>
        </template>
        <b-row v-if="loading">
          <b-col md="6" lg="4" class="pl-1" v-for="i in 6" :key="i">
            <b-card
              no-body
              no-footer
              class="m-3"
            >
              <b-card-body>
                <a-skeleton active />
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
      </div>
      <b-modal id="download-report-modal" ref="modal" :title="modalTitle" hide-footer @hidden="onHidden">
        <b-row align-v="center">
          <b-col>
            <b-form-group id="input-group-2" label="Grupo:" label-for="input-2" description="Seleccione un grupo">
              <b-form-select v-model="groupSelected" :options="groupOptions"></b-form-select>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group id="input-group-2" label="Periodo:" label-for="input-2" description="Seleccione un periodo">
              <b-form-select v-model="periodSelected" :options="periodOptions"></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row align-v="center" v-if="modalType===1">
          <b-col>
            <b-form-checkbox v-show="visibleCheckbox" id="checkbox-1" v-model="isAverage" name="checkbox-1" :value="true" :unchecked-value="false">
              Mostrar promedio por estudiante del periodo seleccionado
            </b-form-checkbox>
            <b-form-checkbox v-show="groupSelected !== null" id="checkbox-2" v-model="messageCheck" name="checkbox-2" :value="true" :unchecked-value="false">
              Agregar mensajes de reporte final
            </b-form-checkbox>
            <b-form-checkbox v-show="groupSelected !== null" id="checkbox-3" v-model="indicatorsCheck" name="checkbox-3" :value="true" :unchecked-value="false">
              Agregar Indicadores
            </b-form-checkbox>
            <b-form-checkbox v-show="visibleCheckbox" id="checkbox-4" name="checkbox-4" switch  v-model="areaCheck">Reporte de Area</b-form-checkbox>
            <b-form-checkbox v-show="visibleCheckbox" id="checkbox-5" v-model="tableCheck" name="checkbox-5" :value="true" :unchecked-value="false">
              Cuadro de promedio
            </b-form-checkbox>
          </b-col>
        </b-row>
        <!-- <b-row>
          <b-button type="submit" variant="primary" class="my-5 mx-2" style="margin-top: 2rem !important;" @click="downloadReport(true)"
          v-if="hasRole(['SU', 'ADMIN', 'ADMIN_ACADEMICO', 'GESTOR_ACADEMICO'])">Descargar 3er y 4to</b-button>
        </b-row> -->
        <b-row>
          <b-col>
            <div v-show="generatingReport">Generando reporte...</div>
            <a-skeleton active  v-show="generatingReport"/>
          </b-col>
        </b-row>
        <b-row class="pull-right">
          <b-col>
            <b-button v-if="modalType===1" variant="primary" class="my-4" style="margin-top: 2rem !important;" @click="downloadReport()">Descargar</b-button>
            <b-button v-if="modalType===2 || modalType===4" variant="primary" class="my-4" style="margin-top: 2rem !important;" @click="downloadReportExcellence()">Descargar</b-button>
            <b-button v-if="modalType===3" variant="primary" class="my-4" style="margin-top: 2rem !important;" @click="downloadReportLowPerformance()">Descargar</b-button>
            <b-button @click="$bvModal.hide('download-report-modal')" variant="light" size="sm" class="mr-2 mb-2 mt-3">Cancelar</b-button>
          </b-col>
        </b-row>
      </b-modal>
      <b-modal id="download-group-list" size="md" ref="modal" title="Descargar listado de estudiantes" hide-footer>
        <b-row align-v="center">
          <b-col sm="8">
            <label style="margin-top: 0.4em;">Incluir documento de identidad</label>
          </b-col>
          <b-col sm="2">
            <b-form-checkbox style="margin-top: 0.4em;" id="check-cc" v-model="requestedFile.params.cc" switch></b-form-checkbox>
          </b-col>
        </b-row>
        <b-row align-v="center">
          <b-col sm="8">
            <label style="margin-top: 0.4em;">Seleccionar todos los grupos</label>
          </b-col>
          <b-col sm="2">
            <b-form-checkbox style="margin-top: 0.4em;" id="check-all-files" v-model="requestedFile.params.allGroups" switch></b-form-checkbox>
          </b-col>
        </b-row>
        <b-row align-v="center" v-if="!requestedFile.params.allGroups">
          <b-col>
            <label class="mt-1 typo__label">Seleccionar grupos</label>
            <multiselect id="selected-groups" v-model="requestedFile.groups" :options="filterGroups.filter(group => group.value !== null && group.value !== 'elective')" :multiple="true" :taggable="true" label="text" track-by="value"
              select-label="Presiona enter para seleccionar" deselect-label="Presiona enter para remover" selected-label="Seleccionado"
              placeholder="Seleccionar grupos" style="margin-top: -4px;">
            </multiselect>
          </b-col>
        </b-row>
        <b-row class="pull-right">
          <b-col>
            <b-button variant="primary" class="my-4" style="margin-top: 2rem !important;" @click="downloadStudentsList()">Descargar</b-button>
            <b-button @click="$bvModal.hide('download-group-list')" variant="light" size="sm" class="mr-2 mb-2 mt-3">Cancelar</b-button>
          </b-col>
        </b-row>
      </b-modal>
    </div>
  </div>
</template>
<style>
  .powerLine {
    padding: 0 !important;
    height: 0.4em;
    width: 100%;
  }
</style>
<script>
import moment from 'moment'
import Swal from 'sweetalert2'
import apiClient from '@/services/axios'
import { mapState } from 'vuex'
import axios from 'axios'
import store from 'store'
import { hasRole, hasPermission, consts, getRoleNameById, showErrorMessage } from '@/services/utilities'
import { showErrorFile } from '@/services/utilities/swal'

export default {
  name: 'ClassList',
  data() {
    return {
      modalType: 1,
      modalTitle: '',
      loading: false,
      classes: [],
      groupSelected: null,
      periodSelected: null,
      childSelected: null,
      hasChildren: false,
      children: [],
      periodOptions: [],
      groupOptions: [],
      generatingReport: false,
      periods: [],
      periodActive: {},
      isAverage: false,
      messageCheck: false,
      indicatorsCheck: false,
      areaCheck: false,
      tableCheck: false,
      isTBG: false,
      gradeData: {},
      filterGroups: [],
      filteredGroup: null,
      consts: consts,
      currentPeriod: false,
      requestedFile: {
        groups: [],
        params: {
          allGroups: false,
          cc: false,
        },
      },
    }
  },
  beforeRouteEnter (to, from, next) {
    const userStorage = JSON.parse(store.get('userData'))
    function getGroupsByUser() {
      if (userStorage.role === getRoleNameById(consts.roles.ESTUDIANTE)) {
        return apiClient.get(`/group-subjects/students/${userStorage.id}/subjects`)
      } else {
        return apiClient.get('/groups')
      }
    }

    function getGroups() {
      return apiClient.get('/groups', {
        params: {
          idSchool: userStorage.idSchool,
          idYear: userStorage.currentYear,
        },
      })
    }

    function getChildren() {
      return apiClient.get(`/users/check-children/${userStorage.id}`)
    }

    function getPeriods() {
      return apiClient.get('/periods')
    }
    if (!(userStorage.role === consts.rolesText.PADRE_MADRE)) {
      axios.all([getGroupsByUser(), getGroups(), getPeriods(), getChildren()])
        .then(axios.spread(function (groupsByUser, groups, periods, children) {
          next((vm) => {
            const groupsData = groups.data.map(x => {
              if (hasPermission([consts.permissions.CREATE_CLASSES_RESOURCES])) {
                if (this.$store.state.user.id === x.idDirector1 || this.$store.state.user.id === x.idDirector2) {
                  return {
                    value: x.id,
                    text: x.name,
                    idDirector1: x.idDirector1,
                    idDirector2: x.idDirector2,
                  }
                }
              } else {
                return {
                  value: x.id,
                  text: x.name,
                  idDirector1: x.idDirector1,
                  idDirector2: x.idDirector2,
                }
              }
            })
            vm.setDataGroupsByUser(null, groupsByUser.data)
            vm.setDataGroups(null, groupsData)
            vm.setDataPeriods(null, periods.data)
            vm.setDataChildren(null, (children !== null) ? children.data : children)
          })
        }))
        .catch(err => {
          next((vm) => {
            vm.setDataGroupsByUser(err, [])
            vm.setDataGroups(err, [])
            vm.setDataPeriods(err, [])
            vm.setDataChildren(err, [])
          })
        })
    } else {
      axios.all([getGroupsByUser(), getPeriods(), getChildren()])
        .then(axios.spread(function (groupsByUser, periods, children) {
          next((vm) => {
            vm.setDataGroupsByUser(null, groupsByUser.data)
            vm.setDataPeriods(null, periods.data)
            vm.setDataChildren(null, (children !== null) ? children.data : children)
          })
        }))
        .catch(err => {
          next((vm) => {
            vm.setDataGroupsByUser(err, [])
            vm.setDataPeriods(err, [])
            vm.setDataChildren(err, [])
          })
        })
    }
  },
  computed: {
    ...mapState(['user']),
    visibleCheckbox: function() {
      if (!this.isTBG || this.periodSelected !== null) {
        this.uncheckIsAverage(1)
      } else if (this.isTBG && this.periodSelected !== null) {
        this.uncheckIsAverage(2)
      }
      return (this.isTBG && this.periodSelected !== null)
    },
  },
  methods: {
    onHidden (e) {
      this.areaCheck = false
      this.messageCheck = false
      this.tableCheck = false
      this.indicatorsCheck = false
      this.isAverage = false
    },
    onImgLoad (classs) {
      classs.loadedImg = true
    },
    periodEnd (periodActive) {
      if (!periodActive) {
        return false
      }
      const now = moment()
      const finalDate = moment(periodActive)
      return finalDate.diff(now, 'seconds') > 1
    },
    uncheckIsAverage(type) {
      switch (type) {
        case 1:
          this.isAverage = false
          break
        case 2:
          this.tableCheck = false
          this.areaCheck = false
          break
      }
    },
    teacherName(teacher) {
      if (teacher) {
        let fullName = teacher.firstName
        if (teacher.secondName !== null && teacher.secondName.length > 1) {
          fullName += ' ' + teacher.secondName
        }
        fullName += ' ' + teacher.firstLastName
        if (teacher.secondLastName !== null && teacher.secondLastName.length > 1) {
          fullName += ' ' + teacher.secondLastName
        }
        return fullName
      } else {
        return 'No asignado'
      }
    },
    setDataGroupsByUser (err, data) {
      if (err) {
        this.error = err.toString()
      } else {
        if (this.user.role === getRoleNameById(consts.roles.ESTUDIANTE)) {
          this.classes = data
        } else {
          data.forEach(clase => {
            if (!this.filterGroups.find(f => f.value === clase.id)) {
              this.filterGroups.push({
                text: clase.name,
                value: clase.id,
              })
            }
          })
          this.filterGroups.unshift({ value: null, text: 'Seleccione un grupo' })
        }
      }
    },
    setDataGroups (err, data) { // Carga la informacion del beforeRouteEnter
      if (err) {
        this.error = err.toString() // TODO Mostrar error
      } else {
        this.groupOptions = data
        const nullGroup = {
          value: null,
          text: 'Seleccione un grado',
          idDirector1: null,
          idDirector2: null,
        }
        this.groupOptions.unshift(nullGroup)
      }
    },
    setDataPeriods (err, data) { // Carga la informacion del beforeRouteEnter
      if (err) {
        this.error = err.toString() // TODO Mostrar error
      } else {
        this.periods = data.results
        this.periodOptions = data.results.rows.map(x => {
          return {
            value: x.id,
            text: x.name,
            idYear: x.idYear,
          }
        })
        const allPeriods = {
          value: null,
          text: 'Todos los periodos',
        }
        this.periodOptions.unshift(allPeriods)
        this.periods.rows.map(p => {
          if (p.active) {
            this.periodActive = p
            this.currentPeriod = true
          }
        })
      }
    },
    setDataChildren(err, data) { // Carga la informacion del beforeRouteEnter
      if (err) {
        this.error = err.toString()
      } else if (data !== null) {
        this.hasChildren = data.length > 0
        if (this.hasChildren) {
          this.children = data.map(x => {
            return {
              value: x.idChild,
              text: x.fullName,
            }
          })
          this.children.unshift({ value: null, text: 'Seleccione el estudiante' })
        }
      }
    },
    hasRole(roles) {
      return hasRole(roles, this.user.role)
    },
    hasPermission(permissions) {
      return hasPermission(permissions, this.user.permissions)
    },
    showDownloadReportModal(type) {
      this.groupOptions[0].text = 'Seleccione un grado'
      switch (type) {
        case 1:
          this.modalTitle = 'Descargar reporte de notas por grupo'
          break
        case 2:
          this.modalTitle = 'Descargar reporte de excelencia académica por grupo'
          break
        case 3:
          this.modalTitle = 'Descargar reporte de bajo rendimiento'
          this.groupOptions[0].text = 'Todos los grados'
          break
        case 4:
          this.modalTitle = 'Descargar reporte de excelencia académica por grupo'
          break
        default:
          break
      }
      this.modalType = type
      this.periodOptions[0].text = !(type === 1) ? 'Todos los periodos' : 'Seleccione un Periodo'
      this.$bvModal.show('download-report-modal')
    },
    showGroupExcelReport() {
      this.$bvModal.show('download-group-list')
    },
    downloadStudentsList() {
      if (!this.requestedFile.params.allGroups && this.requestedFile.groups.length < 1) {
        return Swal.fire({
          title: 'No se han seleccionado grupos',
          icon: 'warning',
        })
      }
      let groups = []
      if (this.requestedFile.params.allGroups) {
        groups = this.filterGroups.map((e) => e.value)
      } else if (this.requestedFile.groups.length > 0) {
        groups = this.requestedFile.groups.map((e) => e.value)
      }
      groups = groups.filter(group => group !== null && group !== 'elective')
      const headers = {
        Authorization: `Bearer ${store.get('accessToken')}`,
        AccessToken: store.get('accessToken'),
      }
      const endNameReport = moment().format('YYYY_MM_DD')
      axios({
        url: `${process.env.VUE_APP_API_URL_V2}/reports/academics/groups/students-xlsx`,
        params: {
          groups,
          cc: this.requestedFile.params.cc,
        },
        method: 'GET',
        responseType: 'blob', // Important
        headers: headers,
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `Lista_de_estudiantes_${endNameReport}.xlsx`) // or any other extension
        document.body.appendChild(link)
        link.click()
      }).catch(error => {
        showErrorFile(error)
      })
    },
    downloadReportZero() {
      const headers = {
        Authorization: `Bearer ${store.get('accessToken')}`,
        AccessToken: store.get('accessToken'),
      }
      const endNameReport = moment().format('YYYY_MM_DD')
      axios({
        url: process.env.VUE_APP_API_URL + '/reports/academics/periods/all/groups/iCansZero',
        method: 'GET',
        responseType: 'blob', // Important
        headers: headers,
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `Reporte_de_Yo_Puedos_en_0_${endNameReport}.xlsx`) // or any other extension
        document.body.appendChild(link)
        link.click()
      }).catch(error => {
        showErrorFile(error)
      })
    },
    downloadReportLowPerformance() {
      this.generatingReport = true
      const nameGroup = this.groupOptions.filter(e => {
        if (e.value === this.groupSelected) {
          return e.text
        }
      })[0].text
      const periodName = this.periodOptions.filter(e => {
        if (e.value === this.periodSelected) {
          return e.text
        }
      })[0].text
      const headers = {
        Authorization: `Bearer ${store.get('accessToken')}`,
        AccessToken: store.get('accessToken'),
      }
      const endNameReport = moment().format('YYYY_MM_DD')
      axios({
        url: process.env.VUE_APP_API_URL + '/reports/academics/periods/all/groups/lowPerformance?group=' + this.groupSelected + '&period=' + this.periodSelected,
        method: 'GET',
        responseType: 'blob', // Important
        headers: headers,
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `Reporte_de_Bajo_Rendimiento_${nameGroup}_periodo_${periodName}_${endNameReport}.xlsx`) // or any other extension
        document.body.appendChild(link)
        link.click()
        this.generatingReport = false
        this.periodSelected = null
        this.groupSelected = null
        this.$bvModal.hide('download-report-modal')
      }).catch(error => {
        showErrorFile(error)
      })
    },
    downloadReportExcellence() {
      if (this.groupSelected === null || this.periodSelected === null) {
        const text = 'Seleccione un'
        return this.$bvToast.toast(text + ((this.groupSelected !== null) ? ' periodo porfavor' : ' grupo porfavor'), {
          title: 'Opción inválida',
          autoHideDelay: 4000,
        })
      }
      const nameGroup = this.groupOptions.filter(e => {
        if (e.value === this.groupSelected) {
          return e.text
        }
      })[0].text
      const headers = {
        Authorization: `Bearer ${store.get('accessToken')}`,
        AccessToken: store.get('accessToken'),
      }
      const endNameReport = moment().format('YYYY_MM_DD')
      const url = (this.modalType === 2) ? '/reports/academics/periods/all/groups/excellence' : '/reports/academics/periods/all/groups/excellence/list'
      axios({
        url: process.env.VUE_APP_API_URL + url + '?group=' + this.groupSelected + '&period=' + this.periodSelected,
        method: 'GET',
        responseType: 'blob', // Important
        headers: headers,
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `Reporte_de_Excelencia_${nameGroup}_${endNameReport}.xlsx`) // or any other extension
        document.body.appendChild(link)
        link.click()
      }).catch(error => {
        showErrorFile(error)
      })
    },
    downloadReport (e3y4 = false) {
      if (this.groupSelected === null) {
        this.$bvToast.toast('Seleccione un grupo porfavor.', {
          title: 'Grupo inválido',
          autoHideDelay: 4000,
        })
        return
      }
      let url = ''
      if (this.areaCheck) {
        url = process.env.VUE_APP_API_URL + `/reports/academics/periods/groups/${this.groupSelected}/area/qualifications`
      } else {
        url = process.env.VUE_APP_API_URL_V2 + '/reports/academics/qualifications'
      }
      let endNameReport = this.gradeData.name.toLowerCase() + '_periodo'
      if (this.periodSelected === null && !this.areaCheck) {
        endNameReport = this.gradeData.name.toLowerCase() + '_Todos_los_periodos'
      } else {
        for (const period of this.periodOptions) {
          if (period.value === this.periodSelected) {
            endNameReport += '_' + period.text.toLowerCase()
            continue
          }
        }
      }
      endNameReport += '_' + moment().format('YYYY_MM_DD')
      const headers = {
        Authorization: `Bearer ${store.get('accessToken')}`,
        AccessToken: store.get('accessToken'),
      }
      this.generatingReport = true
      axios({
        url: url,
        method: 'GET',
        responseType: 'blob', // Important
        params: {
          idPeriod: `${this.periodSelected}`,
          idGroup: this.groupSelected,
          ...(!this.idPeriod && { idYear: this.periodOptions[2].idYear }),
          ...(this.isAverage && { isAverage: true }),
          ...(this.messageCheck && { messageCheck: true }),
          ...(this.indicatorsCheck && { indicatorsCheck: true }),
          ...(this.tableCheck && { tableCheck: true }),
        },
        headers: headers,
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        const filename = this.isTBG ? `Reporte_TBG_${endNameReport}.pdf` : `Reporte_SBG_${endNameReport}.pdf`
        link.setAttribute('download', filename) // or any other extension
        document.body.appendChild(link)
        link.click()
        this.generatingReport = false
        this.periodSelected = null
        this.groupSelected = null
        this.indicatorsCheck = false
        this.uncheckIsAverage()
        this.$bvModal.hide('download-report-modal')
      }).catch(error => {
        showErrorFile(error)
      })
    },
  },
  watch: {
    filteredGroup: function (value) {
      sessionStorage.gradeSelected = this.filteredGroup
      if (value === 'elective' || JSON.parse(value) !== null) {
        this.loading = true
        const elective = value === 'elective' ? '?elective=true' : ''
        apiClient.get(`group-subjects/groups/${value}/subjects${elective}`).then(response => {
          if (this.periodActive.extraPeriodEvaluation) {
            this.classes = response.data.filter(item => item.extraPeriodEvaluation)
          } else {
            this.classes = response.data
          }
          this.loading = false
        }).catch(e => {
          this.$notification.error({
            message: 'Ooops ocurrió un error',
            description: showErrorMessage(e),
          })
        })
      } else {
        this.classes = []
        this.loading = false
      }
    },
    groupSelected: async function (value) {
      if (value !== null && this.modalType === 1) {
        await apiClient.get('/group-subjects/' + value + '?checkByGroup=true').then(response => {
          this.isTBG = response.data.range.system.name === 'QUANTITATIVE'
          this.gradeData = {
            name: response.data.group.name,
            namePeriod: response.data.namePeriodo,
          }
        }).catch(e => {
          this.$notification.error({
            message: 'Ooops ocurrió un error',
            description: showErrorMessage(e),
          })
        })
      }
    },
    childSelected: async function (value) {
      await apiClient.get(`/group-subjects/students/${value}/subjects`).then(response => {
        // this.isTBG = response.data.range.system.name === 'QUANTITATIVE'
        this.classes = response.data
      }).catch(e => {
        this.$notification.error({
          message: 'Ooops ocurrió un error',
          description: showErrorMessage(e),
        })
      })
    },
    periodSelected: async function () {
      if (this.modalType === 1) {
        this.indicatorsCheck = false
      }
      if (this.periodSelected === null) {
        this.isAverage = false
      }
    },
  },
  mounted() {
    if (sessionStorage.gradeSelected && sessionStorage.gradeSelected !== null) {
      this.filteredGroup = sessionStorage.gradeSelected
    }
  },
}
</script>
